import { isServer } from '@flipster/utils/env-helper';

export function getAppInfo(): AppInfo | undefined {
  if (isServer) return undefined;
  return window.getAppInfo?.();
}

interface AppInfo {
  device: string;
  appVersion: string;
  appBuildNumber: string;
  fromBackground: boolean;
  userId?: string;
  email?: string;
}

declare global {
  interface Window {
    // 앱에서 웹뷰에 심어주는 함수.
    // 차트 화면에서만 주입되고 있음.
    getAppInfo?: () => AppInfo;
  }
}
